__turbopack_context__.v({
  "attribution": "image-module-scss-module__rUFylG__attribution",
  "bleed": "image-module-scss-module__rUFylG__bleed",
  "fullwidth": "image-module-scss-module__rUFylG__fullwidth",
  "image": "image-module-scss-module__rUFylG__image",
  "imageWrapper": "image-module-scss-module__rUFylG__imageWrapper",
  "original": "image-module-scss-module__rUFylG__original",
});
